import { Component, Input, SimpleChanges } from "@angular/core";
import { PolicyHeaderComponent } from "../../policy-documents/policy-header/policy-header.component";
import { CommonModule } from "@angular/common";

@Component({
    selector: "app-aul-103-24",
    standalone: true,
    imports: [PolicyHeaderComponent, CommonModule],
    templateUrl: './aul-103-24.component.html',
    styleUrl: './aul-103-24.component.scss'
})
export class Aul10324Component{
    @Input() quoteDetails!: any;

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['quoteDetails']) {
            const updatedAddressInfo = this.transformQuoteData(changes['quoteDetails'].currentValue?.aul10324);
            const transformedClearanceQuestionData = changes['quoteDetails'].currentValue?.aul10324?.clearanceQuestions
            .reduce((acc: any, question: any, index: any) => {
              acc[`q${index + 1}`] = question.response;
              return acc;
          }, {});
            const transformedData = {...changes['quoteDetails'].currentValue?.aul10324, addressInfo: updatedAddressInfo, clearanceAddressQuestion: transformedClearanceQuestionData};
            this.quoteDetails = transformedData;
        }
    }

    transformQuoteData(quoteData: any): any[] {
        const transformedAddresses = quoteData?.addresses?.map((address: any) => {
        // Filter copeDetails based on addressId
        const copeDetails = quoteData?.copeDetails?.find((cd: any) => cd.addressId === address.addressId);
        // Return the transformed address object
          return {
            ...address,
            buildings: copeDetails?.buildings || [], // Ensure buildings are included even if empty
          };
        });
      
        return transformedAddresses;
    }

    getFactor(factors: any[], factorName: string): string {
      return factors?.find(f => f.factorName === factorName)?.subFactorName || '';
    }
}